import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'


import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control
import print from 'vue-print-nb'


import global from './globalFun'

Vue.use(ElementUI, { locale })
Vue.use(VCharts)
Vue.use(print)

// 数据根据值查找排序
Array.prototype.groupBy = function(group) {
  return group && typeof group === 'function' ? Array.prototype.reduce.call(this, function(c, v) {
    let k = group(v)
    if(c.hasOwnProperty(k)){
      c[k].push(v)
    }else {
      c[k] = [v]
    }
    return c
  }, {}):this
}

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js